import { AUTH_PATHS } from '@core/utils/auth-paths'
import type { Dictionary } from '@core/utils/types'
import type { FileRoutesByFullPath } from '@discover/routeTree.gen'
import type { FileRoutesByPath } from '@tanstack/react-router'

export const ROUTES = {
  root: '/',
  ...AUTH_PATHS,

  workspaceRoot: '/$workspaceId',
  agent: '/$workspaceId/agent',
  agentConversation: '/$workspaceId/agent/$conversationId',
  home: '/$workspaceId/home',
  claims: '/$workspaceId/claims',
  claimDetail: '/$workspaceId/claims/$claimId',
  topics: '/$workspaceId/topics',
  topicDetail: '/$workspaceId/topics/$topicId',
  patterns: '/$workspaceId/patterns',
  patternDetail: '/$workspaceId/patterns/$patternId',
  entities: '/$workspaceId/entities',
  coverage: '/$workspaceId/coverage',
  evidence: '/$workspaceId/evidence',
  governance: '/$workspaceId/governance',
  decision: '/$workspaceId/decision',
} as const satisfies Dictionary<keyof FileRoutesByFullPath>

export type ROUTES_TYPE = typeof ROUTES

export const ROUTE_PATHS = {
  root: '/_authenticated/',
  callback: '/(auth)/callback',
  signIn: '/(auth)/sign-in',
  forgotPassword: '/(auth)/forgot-password',
  logOut: '/logout',

  workspaceRoot: '/_authenticated/$workspaceId',
  agent: '/_authenticated/$workspaceId/agent/',
  agentConversation: '/_authenticated/$workspaceId/agent/$conversationId/',
  home: '/_authenticated/$workspaceId/home/',
  claims: '/_authenticated/$workspaceId/claims/',
  claimDetail: '/_authenticated/$workspaceId/claims/$claimId/',
  topics: '/_authenticated/$workspaceId/topics/',
  topicDetail: '/_authenticated/$workspaceId/topics/$topicId/',
  patterns: '/_authenticated/$workspaceId/patterns/',
  patternDetail: '/_authenticated/$workspaceId/patterns/$patternId/',
  entities: '/_authenticated/$workspaceId/entities/',
  coverage: '/_authenticated/$workspaceId/coverage/',
  evidence: '/_authenticated/$workspaceId/evidence/',
  governance: '/_authenticated/$workspaceId/governance/',
  decision: '/_authenticated/$workspaceId/decision/',
} as const satisfies Record<keyof ROUTES_TYPE, keyof FileRoutesByPath>

export type ROUTE_PATHS_TYPE = typeof ROUTE_PATHS
